import { Box, Card, CardContent, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

// ---------------------------------------------------------------------------

export default function RulesTab() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
      }}
    >
      <Card variant="outlined" sx={{ maxWidth: 400, textAlign: 'center', opacity: 0.7 }}>
        <CardContent>
          <LockIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6">
            Rules — Coming Soon
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Set up automated actions based on air quality readings. For example, change the LED
            color when PM2.5 exceeds a threshold.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
